module.exports = __webpack_public_path__ + "static/fonts/Arial-Black.6bf138c2.ttf";